import React from 'react';

const UserCheck = () => {
    return (
        <div>
            <h1>User check done</h1>
        </div>
    );
};

export default UserCheck;